<template>
  <div class="history-container">
    <van-dropdown-menu>
      <van-dropdown-item
        @change="handleChangeStatus"
        v-model="value1"
        :options="option1"
      />
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="order-list">
        <div class="order" v-for="item in list" :key="item.id">
          <div class="base-info">
            <span>{{ item.billNo }} </span>
            <span>{{ item.createAt }}</span>
            <span class="underway" v-if="item.status < 10">进行中</span>
            <span class="underway discard" v-if="item.status == 10">
              已作废
            </span>
            <span class="underway finish" v-if="item.status == 11">已完结</span>
          </div>
          <div class="order-name" @click="handleAdDetail(item.id)">
            {{ item.partyAName }}
          </div>
          <div class="order-price">
            <div>
              <span>预估费用：</span>
              <span class="price">{{ item.estimateTotalCost }}</span>
            </div>
            <div>
              <span>核价费用：</span>
              <span class="price">{{ item.price || "暂无" }}</span>
            </div>
          </div>
          <div class="tips">当前状态</div>
          <div class="steps">
            <span :class="item.status == 0 ? 'active' : ''">协议签订</span>
            <div class="line">———</div>
            <span :class="item.status == 1 ? 'active' : ''">审核</span>
            <div class="line">———</div>
            <span :class="item.status > 1 && item.status < 7 ? 'active' : ''">
              设计
            </span>
            <div class="line">———</div>
            <span :class="item.status > 6 ? 'active' : ''">核价</span>
          </div>
          <van-divider
            v-if="(item.status > 6 && item.status < 10) || item.status == 11"
            dashed
          ></van-divider>
          <div class="btn">
            <van-button
              type="warning"
              @click="handleReimbursement(item.id)"
              v-if="item.status == 7"
            >
              申请报销
            </van-button>
            <van-button
              @click="handleReimbursement(item.id)"
              type="default"
              v-if="item.status == 8"
            >
              报销中
            </van-button>
            <van-button
              type="info"
              @click="handleReimbursement(item.id)"
              v-if="item.status == 11"
            >
              查看
            </van-button>
            <!-- <van-button
              @click="handleReimbursement(item.id)"
              type="default"
              v-if="
                (item.reimbursementSuccessful == null ||
                  item.reimbursementSuccessful == undefined) &&
                  item.status == 8
              "
            >
              报销中
            </van-button> -->
            <!-- <van-button
              @click="handleReimbursement(item.id)"
              type="danger"
              v-if="
                !item.reimbursementSuccessful &&
                  (item.reimbursementSuccessful != null ||
                    item.reimbursementSuccessful != undefined) &&
                  item.status == 8
              "
            >
              报销失败
            </van-button>
            <van-button
              type="primary"
              @click="handleReimbursement(item.id)"
              v-if="item.reimbursementSuccessful && item.status == 8"
            >
              报销成功
            </van-button> -->
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { applyList } from "@/api/advertising";
export default {
  data() {
    return {
      value1: 0,
      option1: [
        {
          text: "全部订单",
          value: 0
        },
        {
          text: "协议签订",
          value: 1
        },
        {
          text: "审核",
          value: 2
        },
        {
          text: "设计",
          value: 3
        },
        {
          text: "核价",
          value: 4
        }
      ],
      listQuery: {
        page: 1,
        size: 10,
        status: 0,
        statusIn: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
      },
      loading: false,
      finished: false,
      list: []
    };
  },
  methods: {
    // 广告列表
    adList() {
      applyList(this.listQuery).then(res => {
        // console.log("广告列表 :>> ", res.result);
        this.loading = false;
        this.listQuery.page++;
        this.list = this.list.concat(res.result);
        if (res.result.length < 10) {
          this.finished = true;
        }
      });
    },
    // 状态筛选
    handleChangeStatus(value) {
      switch (value) {
        case 0:
          this.listQuery.page = 1;
          this.list = [];
          this.listQuery.statusIn = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
          break;
        case 1:
          this.listQuery.page = 1;
          this.list = [];
          this.listQuery.statusIn = [0];
          break;
        case 2:
          this.listQuery.page = 1;
          this.list = [];
          this.listQuery.statusIn = [1];
          break;
        case 3:
          this.listQuery.page = 1;
          this.list = [];
          this.listQuery.statusIn = [2, 3, 4, 5, 6];
          break;
        case 4:
          this.listQuery.page = 1;
          this.list = [];
          this.listQuery.statusIn = [7, 8, 9, 10, 11];
          break;
        default:
          this.listQuery.page = 1;
          this.list = [];
          this.listQuery.statusIn = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
          break;
      }
      this.adList();
    },
    // 申请报销
    handleReimbursement(id) {
      this.$router.push({
        path: "/agency/refund",
        query: {
          id: id
        }
      });
    },
    // 申请详情
    handleAdDetail(id) {
      this.$router.push({
        path: "/agency/deal-detail",
        query: {
          id: id
        }
      });
    },
    // 加载数据
    onLoad() {
      this.adList();
    }
  }
};
</script>
<style lang="scss" scoped>
.history-container {
  .order-list {
    padding: 10px 15px;

    .order {
      padding: 10px;
      margin-bottom: 20px;
      border-radius: 5px;
      background-color: #f9f9f9;
      text-align: left;
      font-size: 16px;
    }

    .base-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .underway {
        color: #03940a;
      }

      .discard {
        color: #ccc;
      }

      .finish {
        color: red;
      }
    }

    .order-name {
      margin-bottom: 10px;
      font-size: 18px;
    }

    .order-price {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .price {
        color: red;
      }
    }

    .tips {
      font-size: 14px;
      color: #5d5b5b;
      margin-bottom: 5px;
    }

    .steps {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        padding: 1px 3px;
      }

      .active {
        background-color: #00a0e9;
        color: #fff;
      }
    }

    .van-divider {
      border-color: #000;
    }

    .btn {
      text-align: center;
    }
  }
}
</style>
